import { useState } from 'react';

import { useTranslation } from 'react-i18next';

import { allowOnlyNumbers } from '@shared/utils';

import type { OtpHandleError, OtpType } from '../model/types';

export const useOtp = (
  startCooldown?: (type: OtpType, durationSeconds?: number) => void,
  otpType?: OtpType
) => {
  const { t } = useTranslation();
  const [code, setCode] = useState('');
  const [inputError, setInputError] = useState<string>();
  const [helperTextError, setHelperTextInputError] = useState<string>();

  const handleError: OtpHandleError = (errors) => {
    const { isLimitExceededError, isLimitExhaustedError } = errors || {};

    if (isLimitExceededError) {
      setInputError(undefined);
      if (otpType) startCooldown?.(otpType);
      setHelperTextInputError(t('OTP:errors.attemptLimitExceeded'));
    } else {
      setHelperTextInputError(undefined);
      setInputError(
        isLimitExhaustedError
          ? t('OTP:errors.attemptLimitExhausted')
          : t('OTP:errors.incorrectCode')
      );
    }

    setCode('');
  };

  const handleCodeChange = (value: string) => {
    setInputError(undefined);
    setHelperTextInputError(undefined);

    const numValues = allowOnlyNumbers(value);
    setCode(numValues);
  };

  const handleEmptyCodeOnSubmit = () => {
    if (code) return;
    setInputError(t('COMMON:errors.required'));
  };

  return {
    code,
    inputError,
    helperTextError,
    handleError,
    handleCodeChange,
    handleEmptyCodeOnSubmit,
  };
};
